<template>
  <div id="app">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-5 col-md-7 col-sm-8 col-12 position-relative">
          <div class="d-flex align-items-center my-5">
            <a href="https://realworks.com.tr" class="logo d-block py-2 border-right">
              <img
                class="img-fluid px-2"
                src="https://firebasestorage.googleapis.com/v0/b/real-career.appspot.com/o/Artboard%201.png?alt=media&token=c397fd29-d468-4896-aa0b-dd222c37a6be"
                alt="Real Works Logo"
              />
            </a>
            <p class="career lead mb-0 mx-2">Career</p>
          </div>
          <form class="form">
            <loading :active.sync="busy" :is-full-page="false" />
            <div class="form-group">
              <label for="position" class="form-label">Açık Pozisyonlar</label>
              <select
                class="form-control"
                name="position"
                id="position"
                v-validate="'required'"
                data-vv-name="Pozisyon"
                v-model="position"
              >
                <option
                  v-for="position in positions"
                  :key="position.id"
                  :value="position.name"
                >{{ position.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="name" class="form-label">İsim</label>
              <input
                type="text"
                v-model="name"
                id="name"
                name="name"
                class="form-control"
                v-validate="'required'"
                data-vv-name="İsim"
              />
              <small class="text-danger">{{ errors.first('İsim') }}</small>
            </div>
            <div class="form-group">
              <label for="surname" class="form-label">Soyisim</label>
              <input
                type="text"
                name="surname"
                v-model="surname"
                id="surname"
                class="form-control"
                v-validate="'required'"
                data-vv-name="Soyisim"
              />
              <small class="text-danger">{{ errors.first('Soyisim') }}</small>
            </div>
            <div class="form-group">
              <label for="email" class="form-label">Email</label>
              <input
                type="email"
                v-model="email"
                id="email"
                name="email"
                class="form-control"
                v-validate="'required|email'"
                data-vv-name="Email"
              />
              <small class="text-danger">{{ errors.first('Email') }}</small>
            </div>
            <div class="form-group">
              <label for="cv" class="form-label">CV</label>
              <input
                type="file"
                name="cv"
                id="cv"
                class="form-control-file"
                accept=".doc, .docx, .pdf"
                v-validate="'required|size:10240'"
                data-vv-name="CV"
                ref="cv"
                @change="previewFiles"
              />
              <small class="text-danger">{{ errors.first('CV') }}</small>
            </div>
            <div class="form-group">
              <button
                @click="submit"
                :disabled="errors.any() || uploading"
                class="btn btn-dark btn-block"
              >GÖNDER</button>
            </div>
          </form>
          <div class="upload-progress position-absolute h-100 w-100" v-if="uploading">
            <p class="text-center">
              <span class="font-weight-bold">{{ filename }}</span> Yükleniyor
            </p>
            <div class="progress">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated bg-dark"
                role="progressbar"
                :style="`width: ${progress}%`"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <span class="text-white font-weight-bold">{{progress}} %</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fs, str } from "./main";
import $ from "jquery";
export default {
  data() {
    return {
      positions: [],
      busy: false,
      name: "",
      surname: "",
      email: "",
      cv: "",
      file: false,
      uploading: false,
      progress: 0,
      position: "",
      filename: ""
    };
  },
  created() {
    let self = this;
    self.busy = true;
    fs.collection("positions")
      .orderBy("name", "asc")
      .where("active", "==", true)
      .get()
      .then(qS => {
        qS.forEach(doc => {
          let data = doc.data();
          data.id = doc.id;
          if (data.prior) {
            self.positions = [data, ...self.positions];
          } else {
            self.positions.push(data);
          }
        });
        self.position = self.positions[0].name;
        self.busy = false;
      });
  },
  mounted() {
    $("form").on("submit", e => {
      e.preventDefault();
    });
  },
  methods: {
    previewFiles() {
      this.file = this.$refs.cv.files[0];
      this.filename = this.file.name;
      if (this.filename.length > 15) {
        let ext = 20 - (this.filename.length - this.filename.lastIndexOf("."));
        let begin = this.filename.substring(0, ext);
        let end = this.filename.substring(
          this.filename.lastIndexOf(".") - 4,
          this.filename.length
        );
        this.filename = begin + "..." + end;
      }
    },
    submit() {
      let self = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          let uploadTask = str
            .ref()
            .child(`cv/${self.file.name}`)
            .put(self.file);
          self.uploading = true;
          uploadTask.on(
            "state_changed",
            function(snapshot) {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              progress = Math.round(progress * 100) / 100;
              self.progress = progress;
            },
            function(error) {
              self.uploading = false;
              self.busy = false;
              alert(`Hata: ${error}\nLütfen daha sonra tekrar deneyiniz.`);
            },
            function() {
              self.uploading = false;
              self.busy = true;
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function(downloadURL) {
                  fs.collection("applications")
                    .add({
                      name: self.name,
                      surname: self.surname,
                      email: self.email,
                      position: self.position,
                      cv: downloadURL,
                      date: Date.now(),
                      archived: false
                    })
                    .then(() => {
                      let data = $("form").serialize();
                      data = data + "&cv=" + encodeURI(downloadURL);
                      $.ajax({
                        type: "GET",
                        url:
                          "https://us-central1-real-career.cloudfunctions.net/sendMails",
                        data: data,
                        error: function(err) {
                          self.busy = false;
                          alert(
                            `Hata: ${err}\nLütfen daha sonra tekrar deneyiniz.`
                          );
                          self.name = "";
                          self.surname = "";
                          self.email = "";
                          self.file = "";
                          document.getElementById("cv").value = "";
                          for (let i = 0; i < self.positions.length; i++) {
                            const element = self.positions[i];
                            if (element.prior) {
                              self.position = element.name;
                            }
                          }
                          self.$validator.errors.items = [];
                          self.$forceUpdate();
                        },
                        success: function() {
                          self.busy = false;
                          alert(
                            "Teşekkürler! Başvurunuz alınmıştır.\nEn kısa sürede sizinle iletişime geçeceğiz."
                          );
                          self.name = "";
                          self.surname = "";
                          self.email = "";
                          self.file = "";
                          document.getElementById("cv").value = "";
                          for (let i = 0; i < self.positions.length; i++) {
                            const element = self.positions[i];
                            if (element.prior) {
                              self.position = element.name;
                            }
                          }
                          self.$validator.errors.items = [];
                          self.$forceUpdate();
                        }
                      });
                    })
                    .catch(error => {
                      self.busy = false;
                      alert(
                        `Hata: ${error}\nLütfen daha sonra tekrar deneyiniz.`
                      );
                    });
                });
            }
          );
        }
      });
    }
  }
};
</script>

<style lang="scss">
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #808080;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(128, 128, 128, 0.25);
}
.career {
  font-size: 42px;
}
@media (max-width: 575px) {
  .career {
    font-size: 10vw;
  }
}
.upload-progress {
  background: #ffffff80;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .progress {
    width: calc(100% - 30px);
    height: 40px;
  }
}
</style>